import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { syncedResourceAllocationFragment } from '~/modules/resourcing/common/fragments';

export const DELETE_TASK_RESOURCE_USER_ALLOCATION = gql`
  mutation deleteTaskResourceUserAllocation(
    $input: DeleteTaskResourceUserAllocationInput!
  ) {
    deleteTaskResourceUserAllocation(input: $input) {
      taskAllocationId
      syncedResourceAllocation {
        ...SyncedResourceAllocation
      }
    }
  }
  ${syncedResourceAllocationFragment}
`;

export const useDeleteTaskResourceUserAllocation = ({
  updateCache,
  refetchQueries
} = {}) => {
  const [deleteTaskResourceUserAllocation, { data, loading }] = useMutation(
    DELETE_TASK_RESOURCE_USER_ALLOCATION
  );

  const deleteTaskResourceUserAllocationCallback = useCallback(
    ({ taskUri, projectUri, taskAllocationId }) =>
      deleteTaskResourceUserAllocation({
        variables: {
          input: {
            taskUri,
            projectUri,
            taskAllocationId
          }
        },
        update: updateCache,
        refetchQueries
      }),
    [deleteTaskResourceUserAllocation, refetchQueries, updateCache]
  );

  return {
    deleteTaskResourceUserAllocation: deleteTaskResourceUserAllocationCallback,
    data,
    loading
  };
};

export default useDeleteTaskResourceUserAllocation;
